import { useCallback, useEffect, useMemo, useReducer, useState } from "react";

import { SiteLayoutComponent, SiteSection } from "shared/components/site-layout";
import { PageWithSettingsComponent, SimpleTitle } from 'shared/components/page-with-settings';
import { usePageMeta } from "shared/mechanics/page-meta";

import { MapCorrelationsSettings } from './components/settings';
import { MapCorrelationsContent } from './components/content';
import { MapCorrelationsCurrency, MapCorrelationSettings, MapCorrelationsMode } from './model'

import { EtfCorrelationService, IEtfCorrelationMapBackend } from "api/correlations";
import { LoadingComponent } from "shared/components/loading";

import { parse as deserializeQueryParams } from "query-string";

interface MapCorrelationsPageParams {
	etf: string | null
}

export const MapCorrelationsPage = () => {
	const [settings, setSettings] = useState<MapCorrelationSettings>({ currency: MapCorrelationsCurrency.RUB, mode: MapCorrelationsMode.CORRELATION });
	const [map, setMap] = useState<IEtfCorrelationMapBackend | null>(null);

	const pageParams = useMemo<MapCorrelationsPageParams>(() => {
		var queryParams = deserializeQueryParams(window.location.search);

		return {
			etf: queryParams['etf']?.toString() || null
		}
	}, []);

	usePageMeta({
		title: 'Матрица корреляций биржевых фондов',
		description: 'Таблица всех корреляций между ETF и БПИФ за всю историю торгов',
		keyWords: ['зависимости', 'корреляции', 'ПИФ', 'коллективные инвестиции'],
		canonicalPath: 'map/correlation'
	});

	useEffect(
		() => {
			setMap(null);
			EtfCorrelationService.map(settings.currency, settings.mode).then(setMap);
		},
		[settings.currency, settings.mode]);

	const content = map == null
		? <LoadingComponent />
		: <MapCorrelationsContent settings={settings} map={map} highlighEtfTicker={pageParams.etf || null} />;

	return (
		<SiteLayoutComponent activeSection={SiteSection.Map}>
			<PageWithSettingsComponent
				defaultIsSettingsExpanded={true}
				settingsTitleChild={props => <SimpleTitle {...props} text="Матрица корреляций" />}
				settingsContentChild={<MapCorrelationsSettings settings={settings} setSettings={setSettings} />}
				settingCompactModeShowButtonText="Матрица корреляций"
				contentChild={content} />
		</SiteLayoutComponent>
	);
}
